import {
  CalculationTimeFrameType,
  type KpiCalculationTimeFrameDto,
  type TimeZone
} from '@hconnect/common/types'
import {TFunction} from 'i18next'
import {useTranslation} from 'react-i18next'

import {
  FEATURE_NAMESPACE,
  QuickSelectionIdsForSlotMap,
  QuickSelectionIdsToCalculationTimeFrameTypeMap
} from '../consts'
import {getPlantStatusQuickSelectionItems} from '../utils'

import {usePlantStatusDateRange} from './usePlantStatusDateRange'

const getTimeFrameForDateRange = (from: Date, to: Date) => {
  const kpiCalculationTimeFrames = [
    {
      calculationTimeFrameType: CalculationTimeFrameType.CustomDateRange,
      startDate: from.toISOString(),
      endDate: to.toISOString()
    }
  ]

  return kpiCalculationTimeFrames
}

const getTimeFramesForQuickSelectionId = (
  quickSelectionId: string,
  timezone: TimeZone,
  t: TFunction
) => {
  const quickSelectionIdsForSelectedId = QuickSelectionIdsForSlotMap[quickSelectionId]
  const quickSelectionItems = getPlantStatusQuickSelectionItems(t, timezone)

  const kpiCalculationTimeFrames = quickSelectionIdsForSelectedId.map((selectionId: string) => {
    const timeFrame = QuickSelectionIdsToCalculationTimeFrameTypeMap[selectionId]
    const foundItem = quickSelectionItems.find((item) => item.id === selectionId)

    if (!foundItem) {
      throw new Error(`Could not find quick selection item for id ${selectionId}`)
    }

    const {dates} = foundItem
    const from = dates[0]
    const to = dates[1]

    return {
      calculationTimeFrameType: timeFrame,
      startDate: from?.toISOString(),
      endDate: to?.toISOString()
    }
  })

  return kpiCalculationTimeFrames
}

type UseTimeFramesProps = {
  timezone: TimeZone
}

export const useTimeFrames = ({timezone}: UseTimeFramesProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {from, to, quickSelectionId} = usePlantStatusDateRange({timezone})

  const timeFrames: KpiCalculationTimeFrameDto[] = quickSelectionId
    ? getTimeFramesForQuickSelectionId(quickSelectionId, timezone, t)
    : getTimeFrameForDateRange(from, to)

  return {
    timeFrames: timeFrames
  }
}
